"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var swr_hooks_1 = require("@l2p/swr-hooks");
var next_intl_1 = require("next-intl");
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var SwitchVip = function (_a) {
    var userType = _a.userType, changeUserType = _a.changeUserType;
    var t = (0, next_intl_1.useTranslations)('translation');
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.button, " ").concat(userType !== swr_hooks_1.USER_TYPES.VIP ? styles_module_scss_1.default.active : ''), onClick: function () {
                changeUserType(swr_hooks_1.USER_TYPES.DEFAULT);
            } },
            react_1.default.createElement("span", null, t('welcomeOffer'))),
        react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.button, " ").concat(userType === swr_hooks_1.USER_TYPES.VIP ? styles_module_scss_1.default.active : ''), onClick: function () {
                changeUserType(swr_hooks_1.USER_TYPES.VIP);
            } },
            react_1.default.createElement("span", null, t('highrollerOffer')))));
};
exports.default = SwitchVip;
